import { CpActionTypes } from '../constants/cp-action-types';

export interface dashboardDataReducerInterface {
    dashBoardData: [];
    surface: string;
    locale: string;
    app: string;
    status: string;
    sortBy: string;
    sortOrder: string;
    aem_id: string;
    searchStr: string;
    selectedUtuts: [];
    searchFrom: number;
    searchSize: number;
}

const intialState = {
    dashBoardData: [],
    surface: 'all',
    locale: 'en_US',
    app: 'all',
    status: 'all',
    sortBy: 'modified_on',
    sortOrder: 'desc',
    aem_id: '',
    searchStr: '',
    selectedUtuts: [],
    searchFrom: 0,
    searchSize: 12,
} as dashboardDataReducerInterface;

export const dashboardDataReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case CpActionTypes.UPDATE_DASHBOARD_DATA:
            return { ...state, dashBoardData: [...payload] };
        case CpActionTypes.UPDATE_SURFACE:
            return { ...state, surface: payload };
        case CpActionTypes.UPDATE_LOCALE:
            return { ...state, locale: payload };
        case CpActionTypes.UPDATE_APP:
            return { ...state, app: payload };
        case CpActionTypes.UPDATE_UTUT_TYPE:
            return { ...state, status: payload };
        case CpActionTypes.UPDATE_SORT_ORDER:
            return { ...state, sortOrder: payload };
        case CpActionTypes.UPDATE_SORT_BY:
            return { ...state, sortBy: payload };
        case CpActionTypes.UPDATE_AEMID:
            return { ...state, aem_id: payload };
        case CpActionTypes.UPDATE_SEARCH_STR:
            return { ...state, searchStr: payload };
        case CpActionTypes.UPDATE_SEARCH_FROM:
            return { ...state, searchFrom: payload };
        case CpActionTypes.UPDATE_SEARCH_SIZE:
            return { ...state, searchSize: payload };
        case CpActionTypes.UPDATE_SELECTED_UTUTS:
            return { ...state, selectedUtuts: [...payload] };
        case CpActionTypes.RESET_ALL_FILTERS:
            return {
                ...state,
                surface: 'all',
                locale: 'en_US',
                app: 'all',
                status: 'all',
                sortBy: 'modified_on',
                sortOrder: 'desc',
                selectedUtuts: [],
                searchFrom: 0,
            };
        default:
            return state;
    }
};
